import React from 'react';

const TotalRevenue = () => {
  return (
    <div className="mr-auto col mb-3">
      <div className="boxes">
        <div className="d-flex mt-3">
          <div className="mt-4 pl-2">
            <img src="https://res.cloudinary.com/teewhy/image/upload/v1545151447/book3.fw.png" alt="" />
          </div>
          <div className="mt-3 p-2">
            <div className="count">WFE</div>
            <h3>Total Revenue</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalRevenue;
